import ErrorState from '@/components/common/ErrorStateComponent';
import LoadingComponent from '@/components/common/LoadingComponent';
import NoDataComponent from '@/components/common/NoDataComponent';
import React from 'react';
import HeadingComponent from '../shared/heading';

const KPIMonthlyPerformanceTable = ({ tableData, loading, error, page }) => {
  if (loading) {
    return (
      <LoadingComponent />
    );
  }

  if (error) {
    return (
      <ErrorState error={error} />
    );
  }

  if (!tableData || !tableData.years || tableData.years.length === 0) {
    return (
      <NoDataComponent message="No data available" />
    );
  }

  return (
    <div className="relative w-full flex flex-col self-start">
      <div className="px-2">
        <div className="flex flex-col gap-0.5 mb-0.5">
        {
          page?.title && <HeadingComponent variant={"main"}>
            {page?.title}
          </HeadingComponent>
        }
        {
          page?.subtitle && <HeadingComponent variant={"sub"}>
            {page?.subtitle}
          </HeadingComponent>
        }
      </div>

        <div className="w-full mx-auto mb-2">
          <div className="bg-card rounded-lg shadow-md" style={{ border: "1px solid black", backgroundColor: "var(--bg-card)" }}>
            <table className="w-full border-collapse table-auto text-[9px]" style={{ border: "1px solid black" }}>
              <thead>
                <tr>
                  <th
                    rowSpan="2"
                    className="w-12 bg-red-600 text-white text-[10px] font-bold text-center align-middle py-0.5"
                    style={{ borderRight: "2px solid #9E9E9E", borderLeft: "1px solid black", borderTop: "1px solid black" }}
                  >
                    {tableData.month}
                  </th>

                  {tableData.years.map((yearData, idx) => (
                    <th
                      key={idx}
                      colSpan={yearData.columns.length}
                      className="text-white border-t text-center text-[10px] font-medium py-0.5"
                      style={{
                        borderRight: idx === tableData.years.length - 1 ? "1px solid black" : "2px solid #9E9E9E",
                        borderTop: "1px solid black",
                        borderBottom: "1px solid #9E9E9E",
                        backgroundColor: "#1a237e"
                      }}
                    >
                      {yearData.year}
                    </th>
                  ))}
                </tr>

                <tr>
                  {tableData.years.map((yearData, yearIdx) =>
                    yearData.columns.map((col, colIdx) => (
                      <th
                        key={`${yearIdx}-${colIdx}`}
                        className="text-white py-0.5 px-1 text-[9px] text-center font-medium"
                        style={{
                          borderRight: (colIdx === yearData.columns.length - 1 && yearIdx !== tableData.years.length - 1) ? "2px solid #9E9E9E" : "1px solid white",
                          borderBottom: "2px solid #9E9E9E",
                          backgroundColor: "#1a237e"
                        }}
                      >
                        {col}
                      </th>
                    ))
                  )}
                </tr>
              </thead>

              <tbody>
                {tableData.rows.map((row, rowIndex) => {
                  let bottomBorderStyle = "1px solid #e5e5e5";

                  if (rowIndex === tableData.rows.length - 1) {
                    bottomBorderStyle = "1px solid black";
                  } else if ([0, 5, 8, 9, 10, 11, 15, 16, 19].includes(rowIndex)) {
                    bottomBorderStyle = "2px solid #9E9E9E";
                  }

                  return (
                    <tr key={rowIndex}>
                      <td
                        className="text-left pl-2 py-0.5 text-white min-w-[150px] text-[9px]"
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "2px solid #9E9E9E",
                          borderBottom: bottomBorderStyle,
                          backgroundColor: "#1a237e"
                        }}
                      >
                        {row.label}
                      </td>

                      {row.values.map((value, colIndex) => {
                        let cellStyle = { border: "1px solid #e5e5e5" };

                        // Calculate year boundaries
                        // let colCount = 0;
                        // tableData.years.forEach((yearData, yearIdx) => {
                        //   const yearStart = colCount;
                        //   const yearEnd = colCount + yearData.columns.length - 1;

                        //   if (colIndex === yearEnd && yearIdx < tableData.years.length - 1) {
                        //     cellStyle.borderRight = "2px solid #9E9E9E";
                        //   }

                        //   colCount += yearData.columns.length;
                        // });

                        let colCount = 0;

                        tableData.years.forEach((yearData, yearIdx) => {
                          const yearStart = colCount;
                          const yearEnd = colCount + yearData.columns.length - 1;
                          const midPoint =
                            yearData.columns.length === 6
                              ? yearStart + 2 // 0-based index → 3rd cell
                              : null;

                          // Border at end of year (existing behavior)
                          if (colIndex === yearEnd && yearIdx < tableData.years.length - 1) {
                            cellStyle.borderRight = "1px solid black";
                          }

                          // ✅ NEW: Border at middle when columns = 6
                          if (midPoint !== null && colIndex === midPoint) {
                            cellStyle.borderRight = "1px solid black";
                          }

                          colCount += yearData.columns.length;
                        });


                        if (colIndex === row.values.length - 1) {
                          cellStyle.borderRight = "1px solid black";
                        }

                        cellStyle.borderBottom = bottomBorderStyle;

                        if (colIndex % 2 === 0) {
                          cellStyle.backgroundColor = "#fefefe";
                        } else {
                          cellStyle.backgroundColor = "#fffacd";
                        }

                        return (
                          <td key={colIndex} className="text-center py-0.5 text-black" style={cellStyle}>
                            {value}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPIMonthlyPerformanceTable;